<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <div v-if="!modoEdicao && !showPerfil">
        <div class="form-edit-page row row-space">
            <div class="form-item flexible">
                <label class="label-caption" for="nmPesquisa">Nome Pesquisa</label>
                <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="80" v-uppercase />
            </div>
            <div class="form-item-char20">
                <StatusCadastroSelect class="form-item" v-model:statusSelecionado="statusPesquisa" />
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="novoCadastro" />
            <button type="button" class="buttom-icon--close" @click="closePage" />
        </div>

        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Nome</th>
                        <th>Email</th>
                        <th>Celular</th>
                        <th>Situação</th>
                        <th>=</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}" 
                        @click="editarCadastro(obj)"
                    >
                        <td class="col-width-integer right">{{ obj.cdusuario }}</td>
                        <td>{{ obj.nmusuario }}</td>
                        <td class="col-width-char40">{{ obj.email }}</td>
                        <td class="col-width-char20 center">{{ obj.celular }}</td>
                        <td class="col-width-char10 center">{{ obj.ativonm }}</td>
                        <td class="col-width-acoes1" @click.stop>
                            <RowActionsMenu
                                :item="obj"
                                :actions="acoesPara(obj)"
                                header="Ações"
                                @action="onRowAction"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


    <div v-if="modoEdicao">
        <UsuarioEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @salvo="lerDados" />
    </div>


    <div v-if="showPerfil">
        <UsuarioPerfilEditPage :usuario="objPerfil" @close="showPerfil = false" @save="lerDados" />
    </div>


    <div>
        <ModalRedefinirSenha
            :visible="showModalSenha"
            @update:visible="(value) => (showModalSenha = value)"
            @submit="redefinirLoginSenha" />
    </div>


    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="showOkModal=false" 
        @confirmed="showOkModal=false" />
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import ModalRedefinirSenha from '@/components/modals/ModalRedefinirSenha.vue';
import RowActionsMenu from '@/components/RowActionsMenu.vue';
import StatusCadastroSelect from '@/selects/estaticos/StatusCadastroSelect.vue';
import UsuarioEditPage from '../formularios/UsuarioEditPage.vue';
import UsuarioPerfilEditPage from '../formularios/UsuarioPerfilEditPage.vue';

const emit = defineEmits(['close']);
const idEdicao = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const nmPesquisa = ref('');
const statusPesquisa = ref('S');

const showModalSenha = ref(false)
const idAlteraLogin = ref(0)

const showOkModal = ref(false)
const msgOkModal = ref(null)

const showPerfil = ref(false)
const objPerfil = ref(null)


function acoesPara(obj) {
    return [
        { key: 'alterar', label: 'Alterar dados', icon: '✏️', visible: obj.cdusuario>0 || globalStore.perfil.sis_admin==1 },
        { key: 'perfil', label: 'Perfil do usuário', icon: '👤', visible: obj.cdusuario>0 || globalStore.perfil.sis_admin==1 },
        { key: 'login', label: 'Alterar login e senha', icon: '🔐', visible: obj.cdusuario>0 || globalStore.perfil.sis_admin==1},
        // { key: 'historico', label: 'Visualizar histórico', icon: '🕘', visible: obj.cdusuario>0 || globalStore.perfil.sis_admin==1},
    ];
}


function closePage(){emit('close')}


function editarCadastro(obj){
    if (obj.cdusuario<0){return;}
    idEdicao.value = obj.id;
    modoEdicao.value = true;
}


async function lerDados(){
    try{
        isLoading.value = true;
        const req = await Api.genericPost('/listas/usuarios', {
            idmunicipio: globalStore.idmunicipio, 
            nmpesquisar: nmPesquisa.value,
            ativo: statusPesquisa.value});
        lsDados.value = req;
    } catch (error){console.error('Erro leitura dos dados', error);
    } finally {isLoading.value = false;}
}


function novoCadastro(){
    idEdicao.value = 0
    modoEdicao.value = true
}


function onRowAction({ key, item }) {
    if (key === 'alterar') editarCadastro(item)
    else if (key === 'perfil') {setRedefirnirPerfil(item)}
    else if (key === 'login') {setRedefirnirSenha(item)}
}


async function redefinirLoginSenha({username, senha}){
    try{
        isLoading.value = true;
        const r = await Api.genericPut('/cad/usuario', {id: idAlteraLogin.value, login: username, senha: senha});
        if (r.bolok == 1){
            msgOkModal.value = 'Nova senha alterada com sucesso'
            showOkModal.value=true
        }else{
            msgOkModal.value = r.erro
            showOkModal.value=true
        }
    } catch (error){console.error('Erro leitura dos dados', error);
    }finally {isLoading.value = false;}
}


function setRedefirnirPerfil(obj){
    objPerfil.value = obj
    showPerfil.value = true
}


function setRedefirnirSenha(obj){
    idAlteraLogin.value = obj.id;
    showModalSenha.value = true;
}


onMounted(lerDados)
</script>
